import { Component, OnInit } from '@angular/core';
import { MrService } from '../../mr.service';
import * as moment from 'moment';

@Component({
  selector: 'app-mr-appointment',
  templateUrl: './mr-appointment.component.html',
  styleUrls: ['./mr-appointment.component.css']
})
export class MrAppointmentComponent implements OnInit {
  parsedData: any;
  mrid:any;
  moment:any=moment
  appt:any;
  appointments: any;

  constructor( private mrservice:MrService) { }
  

  ngOnInit(): void {
    this.getmrappointment();
  }

  getmrappointment(){
    const storedData = localStorage.getItem('myData');
    if (storedData) {
      this.parsedData = JSON.parse(storedData);
      this.mrid = this.parsedData.userData?._id
    } else {
      console.log('No data found in localStorage.');
    }
    this.mrservice.getmrappontment(this.mrid).subscribe((res:any)=>{
      console.log(res);
      this.appointments = res;
    })
  }

  onlogout(){
    this.mrservice.onLogout();
  }

}
